import { render, staticRenderFns } from "./ChatroomMultiselect.vue?vue&type=template&id=500b0048&scoped=true&"
import script from "./ChatroomMultiselect.vue?vue&type=script&lang=js&"
export * from "./ChatroomMultiselect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500b0048",
  null
  
)

export default component.exports